import React, { useState } from 'react';
import { Table } from 'reactstrap';
import { LuArrowDown, LuArrowUp, LuArrowUpDown } from "react-icons/lu";
import { USERS_COLUMNS } from './usersColumns';

// 14px sits with the 13px/600 header label; the old arrow was 22px.
const SORT_ICON_SIZE = 14;

const UsersTableHeader = ({ updateBy, role }) => {
  const [sortState, setSortState] = useState({
    field: '',
    order: ''
  });

  const handleSortBy = (field) => {
    let newOrder;
    if (sortState.field === field && sortState.order === 'asc') {
      newOrder = 'desc';
    } else if (sortState.field === field && sortState.order === 'desc') {
      newOrder = 'default';
    } else {
      newOrder = 'asc';
    }

    if (newOrder === 'default') {
      setSortState({ field: '', order: '' });
      updateBy('default', '');
    } else {
      setSortState({ field, order: newOrder });
      updateBy(field, newOrder);
    }
  };

  const renderSortArrow = (field) => {
    if (field === sortState.field) {
      if (sortState.order === 'asc') {
        return <LuArrowUp size={SORT_ICON_SIZE} className="users-th-sort-icon is-active" />;
      }
      return <LuArrowDown size={SORT_ICON_SIZE} className="users-th-sort-icon is-active" />;
    }
    return <LuArrowUpDown size={SORT_ICON_SIZE} className="users-th-sort-icon" />;
  };

  const getMobileHeading = () => {
    if (role === 'Admin') return 'Mobile Number';
    if (role === 'User' || role === 'Member') return '';
    return 'Phone Number';
  };

  const isAdmin = !['User', 'Member'].includes(role);

  const headingFor = (column) => {
    if (column.key === 'mobileNumber') {
      return getMobileHeading();
    }
    return column.label;
  };

  // Mobile Number and Added Date keep their Admin-only arrows (their cells are
  // Admin-only too); the rest follow the column model.
  const showSortArrow = (column) => {
    if (!column.sortable) return false;
    if (column.key === 'mobileNumber' || column.key === 'addedDate') return isAdmin;
    return true;
  };

  return (
    <Table responsive className="users-table-heading-table">
      <thead>
        <tr className="users-table-heading-row">
          {USERS_COLUMNS.map((column) => (
            <th
              key={column.key}
              className={`users-th users-th-${column.key}`}
              onClick={column.sortable ? () => handleSortBy(column.key) : undefined}
            >
              {headingFor(column)} {showSortArrow(column) && renderSortArrow(column.key)}
            </th>
          ))}
        </tr>
      </thead>
    </Table>
  );
};

export default UsersTableHeader;
